/* eslint-disable */
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const Template = () => {
  const { initializingError, isInitializing } = usePageContentContext();

  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

export default Template;
